module.exports = __webpack_public_path__ + "static/media/re-center.d1c9b5aa.svg";